<template>
  <UModal
    v-model:open="is_open"
    :title="t('comps.modal_donate_success.title', { name: query.first_name as string || 'dyrevenn' })"
  >
    <template #body>
      <div class="flex justify-center">
        <UIcon
          name="i-lucide-heart-handshake"
          class="mx-auto mt-2 mb-6 w-[140px] h-[140px] text-primary-500"
        />
      </div>
      <LayoutP class="mb-2">
        {{ t('comps.modal_donate_success.description') }}
      </LayoutP>
      <LayoutP>{{ t('comps.modal_donate_success.receipt_notice', { donation_type: query.recurring === 'true' ? t('comps.modal_donate_success.receipt_recurring') : t('comps.modal_donate_success.receipt_one_time') }) }}</LayoutP>
    </template>
    <template #footer>
      <div class="flex justify-center w-full">
        <UButton
          class="self-center mx-auto"
          size="xl"
          :label="t('comps.modal_donate_success.btn_close')"
          @click="is_open = false"
        />
      </div>
    </template>
  </UModal>
</template>

<script setup lang="ts">
import type { DonateSuccessSchema } from '#shared/utils/schemas'

const { data: { donate } } = getData()

const is_open = ref(false)
const { query } = useRoute()

onMounted(async () => {
  if ('donate-success' in query) {
    is_open.value = true

    const { api_endpoint } = useRuntimeConfig().public

    const { event_source_url, fbc, fbp, event_id, meta_event_time, event } = useTracker()

    event({
      meta: 'Donate',
      snapchat: 'PURCHASE',
      google: 'donate_success',
      tiktok: 'Purchase',
    }, {
      first_name: query.first_name as string,
      last_name: query.last_name as string,
      email: query.email as string,
      phone: query.phone as string,
    }, {
      value: Number(query.amount),
      currency: donate.currency,
    })

    const reqBody: DonateSuccessSchema = {
      first_name: query.first_name as string,
      last_name: query.last_name as string,
      email: query.email as string,
      amount: Number(query.amount),
      recurring: query.recurring === 'true',
      phone: query.phone ? (query.phone as string) : undefined,
      meta_event_time,
      event_id,
      fbc,
      fbp,
      event_source_url,
    }

    const newQuery = { ...query }
    delete newQuery['donate-success']
    await navigateTo({
      query: newQuery,
      replace: true,
    })

    await $fetch(`${api_endpoint}/donate-success`, {
      method: 'POST',
      body: reqBody,
    })
  }
})
</script>
